import store from "../store/index.js";

export default {
    typeOf(obj) {
        return {}.toString
            .call(obj)
            .split(" ")[1]
            .slice(0, -1)
            .toLowerCase();
    },

    isEmpty(input) {
        // array
        if (this.typeOf(input) === "array") {
            return input.length === 0;
        }

        // int
        if (this.typeOf(input) === "number") {
            if (input === 0) {
                return false;
            }

            return !input;
        }

        // undefined, null, string, object
        return !input || Object.keys(input).length === 0;
    },

    hasPermission(codename) {
        if (!store.state.user.me) {
            return false;
        }

        const _permissions = store.state.user.me.permissions;

        let _check_permission = _permissions.find(
            item => item.codename === codename
        );

        return _check_permission ? true : false;
        // return codename;
    },

    countDaysInRangeByMonth(startDate, endDate) {
        const _startDate = new Date(startDate);
        const _endDate = new Date(endDate);

        if (_endDate < _startDate) {
            return {};
        }

        var dict = {};

        // loop for every day
        for (
            var day = _startDate;
            day <= _endDate;
            day.setDate(day.getDate() + 1)
        ) {
            let m = day.getMonth() + 1;

            dict[m] = (dict[m] || 0) + 1;
        }

        return dict;
    },

    allAreNull(arr) {
        return arr.every(element => element === null);
    }
};
